
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/axi/register",
      function () {
        return require("private-next-pages/axi/register.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/axi/register"])
      });
    }
  